import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useDisplay from "../../hooks/useDisplay";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import { route } from "../../router/route";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import Pagination from "./../../components/molecules/pagination";
import { activitySubTabList, tabList } from "./../../constant/myPageTab";
import LSBdDisplay03 from "./../../components/molecules/text/linSeedKr/Bd/lsBdDisplay03";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "../../components/organisms/SelectBox";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import CouponApi from "../../api/coupon.api";
import moment from "moment";
import { formatNumberWithCommas } from "../../util/formatNumber";
import Empty from "../../components/molecules/empty";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";
import Loading from "../../components/templates/loading";
import { errorHandler } from "../../util/errorHandler";
import { toast } from "react-toastify";

const MyPageActivityCoupon = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line
  const location = useLocation();

  // ---------- 모바일 버전 탭 관련 ---------- //
  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[1].title);

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    activitySubTabList[3].title,
  );

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          route.my_page_activity_coupon,
        )}`,
        { replace: true },
      );
      return;
    }

    getCouponList();
  }, [location]); // eslint-disable-line

  // ---------- 페이지네이션 관련 ---------- //
  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 5, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 1,
  });

  // ---------- 게시물 리스트 가져오기 ---------- //
  const [couponList, setCouponList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getCouponList = async () => {
    if (sessionStorage.getItem("isLogin") !== "true") return;

    try {
      setIsLoading(true);
      const data = {
        page: page || 1,
        size: pagination.size,
        myFlag: "Active",
      };
      const response = (await CouponApi.getList(data)).data.data;

      setCouponList((response?.content ?? []).filter((item) => item?.coupon));

      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages:
          response.totalPage ||
          Math.max(1, Math.ceil(response.totalCount / prev.size)),
      }));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000",
              marginBottom: 32,
            }}
          >
            👨‍💻 마이페이지
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {tabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 1 ? true : false}
                    title={tab.title}
                  />

                  {index === 1 && (
                    <SubTabWrapper>
                      {activitySubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={index === 3 ? true : false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                <ContentHeaderWrapper>
                  <LSRgDisplay02 style={{ color: "#000" }}>
                    쿠폰 관리
                  </LSRgDisplay02>
                </ContentHeaderWrapper>

                {/* 본문 영역 - 쿠폰 리스트 */}
                <ContentBodyWrapper>
                  {isLoading ? (
                    <Loading />
                  ) : couponList.length > 0 ? (
                    couponList.map((item, index) => (
                      <CouponWrapper
                        key={item.id}
                        disabled={item?.couponStatus !== "POSSIBLE" && true}
                      >
                        <CouponTextWrapper>
                          <LSBdH2HeadLine
                            style={{
                              color:
                                item?.couponStatus !== "POSSIBLE"
                                  ? "#898E99"
                                  : "#000",
                            }}
                          >
                            {item?.coupon?.title || ""}
                          </LSBdH2HeadLine>
                          <LSRgBody01
                            style={{
                              color:
                                item?.couponStatus !== "POSSIBLE"
                                  ? "#898E99"
                                  : "#000",
                            }}
                          >
                            {moment(item?.coupon?.endDate).format(
                              "YYYY.MM.DD HH:mm",
                            )}
                            까지
                          </LSRgBody01>
                        </CouponTextWrapper>
                        <LSBdDisplay03
                          style={{
                            color:
                              item?.couponStatus !== "POSSIBLE"
                                ? "#A4A8B1"
                                : "#5050FF",
                          }}
                        >
                          {item?.coupon?.couponType === "RATIO"
                            ? `${formatNumberWithCommas(
                                item?.coupon?.amount || 0,
                              )}%`
                            : `${formatNumberWithCommas(
                                item?.coupon?.amount || 0,
                              )}원`}
                        </LSBdDisplay03>
                      </CouponWrapper>
                    ))
                  ) : (
                    <Empty title="쿠폰이 없습니다." />
                  )}
                </ContentBodyWrapper>

                {couponList.length > 0 && pagination.totalCount > 5 && (
                  <Pagination
                    route={route.my_page_activity_coupon}
                    queryString={``}
                    currentPage={Number(page) || 1}
                    totalPages={pagination.totalPages}
                    rangeSize={pagination.rangeSize}
                  />
                )}
              </ContentContainer>
            </div>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={tabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={activitySubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <LSRgH1HeadLine style={{ marginBottom: 20 }}>
              쿠폰 관리
            </LSRgH1HeadLine>

            {/* 본문 영역 - 쿠폰 리스트 */}
            <ContentBodyWrapper $isSmall={isSmall}>
              {isLoading ? (
                <Loading />
              ) : couponList.length > 0 ? (
                couponList.map((item, index) => (
                  <CouponWrapper
                    key={item.id}
                    disabled={item?.couponStatus !== "POSSIBLE" && true}
                    $isSmall={isSmall}
                  >
                    <CouponTextWrapper $isSmall={isSmall}>
                      <LSBdDisplay03
                        style={{
                          color:
                            item?.couponStatus !== "POSSIBLE"
                              ? "#A4A8B1"
                              : "#5050FF",
                          marginBottom: 12,
                        }}
                      >
                        {item?.coupon?.couponType === "RATIO"
                          ? `${formatNumberWithCommas(
                              item?.coupon?.amount || 0,
                            )}%`
                          : `${formatNumberWithCommas(
                              item?.coupon?.amount || 0,
                            )}원`}
                      </LSBdDisplay03>
                      <LSBdH1HeadLine
                        style={{
                          color:
                            item?.couponStatus !== "POSSIBLE"
                              ? "#898E99"
                              : "#000",
                        }}
                      >
                        {item?.coupon?.title || ""}
                      </LSBdH1HeadLine>
                      <LSRgCaption02
                        style={{
                          color:
                            item?.couponStatus !== "POSSIBLE"
                              ? "#898E99"
                              : "#000",
                        }}
                      >
                        {moment(item?.coupon?.endDate).format(
                          "YYYY.MM.DD HH:mm",
                        )}
                        까지
                      </LSRgCaption02>
                    </CouponTextWrapper>
                  </CouponWrapper>
                ))
              ) : (
                <Empty title="쿠폰이 없습니다." />
              )}
            </ContentBodyWrapper>

            {couponList.length > 0 && pagination.totalCount > 5 && (
              <Pagination
                route={route.my_page_activity_coupon}
                queryString={``}
                currentPage={Number(page) || 1}
                totalPages={pagination.totalPages}
                rangeSize={pagination.rangeSize}
              />
            )}
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default MyPageActivityCoupon;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "16px" : "4px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const ContentBodyWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "15px" : "20px")};
`;

const CouponWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => (props.$isSmall ? "20px" : "32px 39px;")};
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: ${(props) => (props.$isSmall ? "149px " : "117px")};
  background-color: ${(props) => (props.disabled ? "#F6F6F6" : "#F6F6FF")};
  border: ${(props) =>
    props.disabled ? "1px solid #F6F6F6" : "1px solid #E3E3FF"};
  border-radius: 20px;
`;

const CouponTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
`;
